/* eslint-disable */
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";

export class KundorderListRequestDTO   {

    public ordernummer: string;
    public beskrivning: string;
    public avtalsansvarig: TypeAheadDTO;
    public kundordertyp: string;
    public handelssortiment: HandelssortimentTreeType[];
    public id: number;
    public kund: NamnIdDTO;
    public mottagningsplats: NamnIdDTO;
    public periodFrom: string;
    public periodTom: string;

    constructor() {
        this.ordernummer = undefined;
        this.beskrivning = undefined;
        this.avtalsansvarig = undefined;
        this.kundordertyp = undefined;
        this.handelssortiment = undefined;
        this.id = undefined;
        this.kund = undefined;
        this.mottagningsplats = undefined;
        this.periodFrom = undefined;
        this.periodTom = undefined;
    }
}
export class HandelssortimentTreeType   {

    public id: number;
    public typ: string;

    constructor() {
        this.id = undefined;
        this.typ = undefined;
    }
}
export class NamnIdDTO   {

    public id: number;
    public namn: string;

    constructor() {
        this.id = undefined;
        this.namn = undefined;
    }
}
